export default function getResource(label) {
    const resources = {
        review: 'commentaire',
        reviews: 'commentaires'
    };
    return resources[label];
}
